/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '@/cart/api';
import { StoreConfigModel } from '@/cart/data/models';
import { transformStoreConfig } from '@/cart/data/transforms';
import { handleFetchError } from '@/cart/lib/fetch-error';

import { STORE_CONFIG_QUERY } from './graphql/StoreConfigQuery';

export const getStoreConfig = async (): Promise<StoreConfigModel | null> => {
  return fetchGraphQl(STORE_CONFIG_QUERY, {
    method: 'GET',
    cache: 'force-cache',
  }).then(({ errors, data }) => {
    if (errors) return handleFetchError(errors);

    return transformStoreConfig(data.storeConfig);
  });
};
